import { DEPARTMENT_CODES } from "../../constant/department-code-constant";

export const getDepartmentHome = (dept?: string) => {
    switch (dept) {
        case DEPARTMENT_CODES.MKT_GMS:
            return "/create-proposal";
        case DEPARTMENT_CODES.ACTUARIAL:
            return "/computation-proposal";
        case DEPARTMENT_CODES.IT:
            return "/new-user";
        case DEPARTMENT_CODES.EBAM:
            return "/policy-creation";
        case 'error':
            return "/login";
        default:
            return "/unauthorized";
    }
};